<template>
  <div class="table" ref="tableRef">
    <!-- 自定义选择菜单 -->
    <div v-if="showSelectMenu" class="select-menu" :style="selectMenuStyle">
      <!-- <div class="select-menu-item" @click="handleSelectAll">Select ALL</div> -->
      <div class="select-menu-item" @click="handleSelectThisPage">
        {{ $t('seller.productTable.selectThisPage') }}
      </div>
    </div>
 <!-- :row-selection="{
        selectedRowKeys: props.selectedRowKeys,
        onSelectAll: onSelectAll,
        onSelect: onSelect,
        type: 'checkbox',
        // 禁用表格的默认全选逻辑，我们自己处理
        onSelectAllChange: () => {},
      }" -->
    <artmisads-table
      :row-selection="{
          selectedRowKeys: props.selectedRowKeys,
          onChange: onSelectChange,
           getCheckboxProps: (record) => ({
            disabled: record?.statusChangeOperations?.length?record?.statusChangeOperations?.[0]?.entityType !== 'PRODUCT':false
          })
      }"
      :columns="columns"
      row-key="id"
      :data-source="props.dataSource"
      :pagination="{
        total: props.listTotal,
        current: props.params.page,
        pageSize: props.params.size,
        showSizeChanger: true,
      }"
      :loading="props.loading"
      :change="onChangePage"
      rowClassName="table-item"
      :scroll="{ x: 1200 }"
      :noData="props.noData"
    >
      <template #emptyText>
        <div>
          <svg
            width="64"
            height="41"
            viewBox="0 0 64 41"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
              <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
              <g fill-rule="nonzero" stroke="#d9d9d9">
                <path
                  d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
                ></path>
                <path
                  d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                  fill="#fafafa"
                ></path>
              </g>
            </g>
          </svg>
        </div>
        <p class="ant-empty-description">{{ $t('seller.productTable.emptyNoData') }}</p>
        <p class="ant-empty-description">
          {{ $t('seller.productTable.emptySyncHint') }}
        </p>
        <div class="re-fetch-wrap">
          <reFetch
            :key="product"
            type="product"
            :showTime="false"
            :refetch="props.getProductList"
          />
        </div>
      </template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.name === 'action'">
          <div class="set-commission">
            <artmisads-select-button
              size="small"
              @click="() => onSetCommission(record.id, record,'single')"
              v-if="props.activeTab === '0'"
              >{{ $t('seller.brandsPage.setCommission') }}</artmisads-select-button
            >
            <!-- <artmisads-select-button size="small" @click="() => onSetCommission(record.id)" v-if="props.activeTab === '1' && record.status === 'active'">Set Up Partnership</artmisads-select-button> -->
            <template v-if="props.activeTab === '0'">
              <artmisads-button
                :isSquare="true"
                type="primary"
                v-if="record.status === 'inactive' && !record.timeMonth"
                size="small"
                @click="onOpenModal(record, 'activate')"
                >{{ $t('seller.brandsPage.activate') }}</artmisads-button
              >
              <artmisads-button
                :isSquare="true"
                type="primary"
                v-if="
                  record.status === 'inactive' &&
                  record.timeMonth &&
                  record.entityType == 'BRAND'
                "
                size="small"
                @click="onOpenModal(record, 'activate')"
                disabled
                >{{ $t('seller.brandsPage.activate') }}</artmisads-button
              >
              <a-popover
                placement="left"
                v-if="
                  record.status == 'inactive' &&
                  record.timeMonth &&
                  record.entityType != 'BRAND'
                "
              >
                <template #content>
                  <div class="contentBox">
                    <div class="popoverContent">
                      <span v-if="record.entityType == 'BRAND'">{{
                        $t('seller.productTable.brandChangeNotice')
                      }}</span>
                      <p>
                        {{
                          $t('seller.productTable.productStatusChangePopover', {
                            status: nextScheduledProductStatus(record),
                            date: record.timeMonthNameEOD,
                          })
                        }}
                      </p>
                    </div>
                    <div class="cancelBtn" @click="cancelBrand(record)">
                      {{ $t('seller.common.cancel') }}
                    </div>
                  </div>
                </template>
                <template #title>
                  <span></span>
                </template>
                <artmisads-button
                  disabled
                  :isSquare="true"
                  type="primary"
                  size="small"
                >
                  {{ $t('seller.brandsPage.activate') }}
                </artmisads-button>
              </a-popover>
              <artmisads-select-button
                v-if="record.status === 'active' && !record.timeMonth"
                size="small"
                @click="onOpenModal(record, 'deactive')"
                >{{ $t('seller.brandsPage.deactivate') }}</artmisads-select-button
              >
              <artmisads-select-button
                v-if="
                  record.status === 'active' &&
                  record.timeMonth &&
                  record.entityType == 'BRAND'
                "
                size="small"
                @click="onOpenModal(record, 'deactive')"
                disabled
                >{{ $t('seller.brandsPage.deactivate') }}</artmisads-select-button
              >
              <a-popover
                placement="left"
                v-if="
                  record.status == 'active' &&
                  record.timeMonth &&
                  record.entityType != 'BRAND'
                "
              >
                <template #content>
                  <div class="contentBox">
                    <div class="popoverContent">
                      <span v-if="record.entityType == 'BRAND'">{{
                        $t('seller.productTable.brandChangeNotice')
                      }}</span>
                      <p>
                        {{
                          $t('seller.productTable.productStatusChangePopover', {
                            status: nextScheduledProductStatus(record),
                            date: record.timeMonthNameEOD,
                          })
                        }}
                      </p>
                    </div>
                    <div class="cancelBtn" @click="cancelBrand(record)">
                      {{ $t('seller.common.cancel') }}
                    </div>
                  </div>
                </template>
                <template #title>
                  <span></span>
                </template>
                <artmisads-select-button
                  disabled
                  size="small"
                  @click="onOpenModal(record, 'deactive')"
                >
                  {{ $t('seller.brandsPage.deactivate') }}
                </artmisads-select-button>
              </a-popover>
            </template>
            <template v-else>
              <artmisads-button
                :isSquare="true"
                type="primary"
                v-if="
                  record.associateStatus === 'inactive' && !record.timeMonth
                "
                size="small"
                @click="onOpenModal(record, 'activate')"
                >{{ $t('seller.brandsPage.activate') }}</artmisads-button
              >
              <artmisads-button
                :isSquare="true"
                type="primary"
                v-if="
                  record.associateStatus === 'inactive' &&
                  record.timeMonth &&
                  record.entityType == 'BRAND'
                "
                size="small"
                @click="onOpenModal(record, 'activate')"
                disabled
                >{{ $t('seller.brandsPage.activate') }}</artmisads-button
              >
              <a-popover
                placement="left"
                v-if="
                  record.associateStatus == 'inactive' &&
                  record.timeMonth &&
                  record.entityType != 'BRAND'
                "
              >
                <template #content>
                  <div class="contentBox">
                    <div class="popoverContent">
                      <span v-if="record.entityType == 'BRAND'">{{
                        $t('seller.productTable.brandChangeNotice')
                      }}</span>
                      <p>
                        {{
                          $t('seller.productTable.productStatusChangePopover', {
                            status: nextScheduledProductStatus(record),
                            date: record.timeMonthNameEOD,
                          })
                        }}
                      </p>
                    </div>
                    <div class="cancelBtn" @click="cancelBrand(record)">
                      {{ $t('seller.common.cancel') }}
                    </div>
                  </div>
                </template>
                <template #title>
                  <span></span>
                </template>
                <artmisads-button
                  disabled
                  :isSquare="true"
                  type="primary"
                  size="small"
                >
                  {{ $t('seller.brandsPage.activate') }}
                </artmisads-button>
              </a-popover>
              <artmisads-select-button
                v-if="record.associateStatus === 'active' && !record.timeMonth"
                size="small"
                @click="onOpenModal(record, 'deactive')"
                >{{ $t('seller.brandsPage.deactivate') }}</artmisads-select-button
              >
              <artmisads-select-button
                v-if="
                  record.associateStatus === 'active' &&
                  record.timeMonth &&
                  record.entityType == 'BRAND'
                "
                size="small"
                @click="onOpenModal(record, 'deactive')"
                disabled
                >{{ $t('seller.brandsPage.deactivate') }}</artmisads-select-button
              >
              <a-popover
                placement="left"
                v-if="
                  record.associateStatus == 'active' &&
                  record.timeMonth &&
                  record.entityType != 'BRAND'
                "
              >
                <template #content>
                  <div class="contentBox">
                    <div class="popoverContent">
                      <span v-if="record.entityType == 'BRAND'">{{
                        $t('seller.productTable.brandChangeNotice')
                      }}</span>
                      <p>
                        {{
                          $t('seller.productTable.productStatusChangePopover', {
                            status: nextScheduledProductStatus(record),
                            date: record.timeMonthNameEOD,
                          })
                        }}
                      </p>
                    </div>
                    <div class="cancelBtn" @click="cancelBrand(record)">
                      {{ $t('seller.common.cancel') }}
                    </div>
                  </div>
                </template>
                <template #title>
                  <span></span>
                </template>
                <artmisads-select-button
                  disabled
                  size="small"
                  @click="onOpenModal(record, 'deactive')"
                >
                  {{ $t('seller.brandsPage.deactivate') }}
                </artmisads-select-button>
              </a-popover>
            </template>
          </div>
        </template>
        <template v-if="column.name === 'commission'">
          <span
            :class="
              'fw500 ' +
              (record.status === 'active'
                ? 'active-commission'
                : 'inactive-commission')
            "
            >{{ `${Number(record?.commission || 0).toFixed(1)}%` }}</span
          >
        </template>
        <template v-if="column.name === 'status'">
          <showStatus :isActive="record.status === 'active'" :noBorder="true" />
          <div class="time" v-if="record.timeMonth">
            <a-popover placement="bottom">
              <template #content>
                <div class="contentBox">
                  <div class="popoverContent">
                    <span v-if="record.entityType == 'BRAND'">{{
                      $t('seller.productTable.brandChangeNotice')
                    }}</span>
                    <p>
                      {{
                        $t('seller.productTable.productStatusChangePopover', {
                          status: nextScheduledProductStatus(record),
                          date: record.timeMonthNameEOD,
                        })
                      }}
                    </p>
                  </div>
                  <div
                    class="cancelBtn"
                    @click="cancelBrand(record)"
                    v-if="record.entityType != 'BRAND'"
                  >
                    {{ $t('seller.common.cancel') }}
                  </div>
                </div>
              </template>
              <template #title>
                <span></span>
              </template>
              <div class="time-mid">
                <Icon name="Frame" />
                <span class="time-month">{{
                  $t('seller.brandsPage.untilEod', { month: record.timeMonth })
                }}</span>
                <Icon name="a-error-tianchong5" class="close-icon" />
              </div>
            </a-popover>
          </div>
        </template>
        <template v-if="column.name === 'associateStatus'">
          <showStatus
            :isActive="record.associateStatus === 'active'"
            :noBorder="true"
          />

          <div class="time" v-if="record.timeMonth">
            <a-popover placement="bottom">
              <template #content>
                <div class="contentBox">
                  <div class="popoverContent">
                    <span v-if="record.entityType == 'BRAND'">{{
                      $t('seller.productTable.brandChangeNotice')
                    }}</span>
                    <p>
                      {{
                        $t('seller.productTable.productStatusChangePopover', {
                          status: nextScheduledProductStatus(record),
                          date: record.timeMonthNameEOD,
                        })
                      }}
                    </p>
                  </div>
                  <div
                    class="cancelBtn"
                    @click="cancelBrand(record)"
                    v-if="record.entityType != 'BRAND'"
                  >
                    {{ $t('seller.common.cancel') }}
                  </div>
                </div>
              </template>
              <template #title>
                <span></span>
              </template>
              <div class="time-mid">
                <Icon name="Frame" />
                <span class="time-month">{{
                  $t('seller.brandsPage.untilEod', { month: record.timeMonth })
                }}</span>
                <Icon name="a-error-tianchong5" class="close-icon" />
              </div>
            </a-popover>
          </div>
        </template>
        <template v-if="column.name === 'attributionCommission'">
          {{ returnAttributionCommission(record) }}
          <div class="time" v-if="record.timeMonthCommission">
            <Icon name="Frame" />
            <span class="time-month">{{
              $t('seller.productTable.commissionFromMonth', {
                rate: returnAttributionCommissionBottom(record),
                month: record.timeMonthCommission,
              })
            }}</span>
            <a-popover placement="bottom">
              <template #content>
                <div class="contentBox">
                  {{
                    $t('seller.productTable.commissionChangePopover', {
                      rate: returnAttributionCommissionBottom(record),
                      date: record.timeMonthCommission,
                    })
                  }}
                  <div
                    class="cancelBtn"
                    @click="cancelBrand(record, 'commissionChangeOperations')"
                  >
                    {{ $t('seller.common.cancel') }}
                  </div>
                </div>
              </template>
              <template #title>
                <span></span>
              </template>
              <Icon name="a-error-tianchong5" class="close-icon" />
            </a-popover>
          </div>
        </template>
        <template v-if="column.name === 'amazonName'">
          <div>
            <!--  -->
            <div v-if="record.amazonName" class="amazon-name">
              {{ record.amazonName }}
            </div>
            <div class="no-amazonName" v-else>--</div>
          </div>
        </template>
        <template v-if="column.name === 'deal'">
          <div>
            <product-deals-column
              v-if="record.productDeals?.length"
              v-for="item in record.productDeals"
              :record="item"
              :key="item.id"
            />
            <div class="no-deal" v-else>--</div>
          </div>
        </template>
        <template v-if="column.name === 'price'">
          <price :record="record" />
        </template>
      </template>
    </artmisads-table>

    <TableModal
      :selectedRowKeys="props.selectedRowKeys"
      :productCountInfo="productCountInfo"
      :configs="modalConfigs"
      :item="singleRecord"
      @cancel="onModalCancel"
      @ok="onModalOK"
      @okMulti="onMultiOK"
    />
    <SuerModal
      :configs="suerModalConfigs"
      :item="recordSuerModal"
      @cancel="onSureCancel"
      @ok="onSureOK"
    />
  </div>
</template>
<script lang="jsx" setup>
import { ref, watch, defineExpose, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import showStatus from '../brands/components/showStatus.vue'
import productDealsColumn from '~/components/productDealsColumn.vue'
import { productsApi, brandApi } from '@/server/index'
import Icon from '@/components/Icon.vue'
import Price from '~/components/Price.vue'
import VcIcon from '~/components/VcIcon.vue'
import reFetch from '../brands/components/reFetch.vue'
import { message } from 'ant-design-vue'
import TableModal from './tableModal.vue'
import SuerModal from './suerModal.vue'
const productCountInfo = ref(0)
const emit = defineEmits(['cancel'])

// 多选交互 - 全选功能实现
const selectAllRows = ref([])

// 自定义选择菜单控制
const showSelectMenu = ref(false)
const selectMenuStyle = ref({})
const menuPosition = ref({ left: 0, top: 0 })

// 重写全选函数，使用自定义菜单替代默认行为
const onSelectAll = (selected, selectedRows, changeRows) => {
  // 保存当前页的所有数据，过滤掉undefined项
  const currentRows = (props.dataSource || []).filter((item) => item && item.id)
  selectAllRows.value = currentRows

  // 获取全选复选框的位置
  const selectAllCheckbox = document.querySelector(
    '.ant-table-thead .ant-table-selection-column .ant-checkbox',
  )
  if (selectAllCheckbox) {
    const rect = selectAllCheckbox.getBoundingClientRect()

    // 计算菜单位置
    const left = rect.left + 4
    const top = rect.bottom + window.scrollY

    // 设置菜单样式和位置
    selectMenuStyle.value = {
      position: 'absolute',
      left: `${0}px`,
      top: `${42}px`,
      zIndex: 10000,
      background: 'white',
      border: '1px solid #e1e1e1',
      borderRadius: '4px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      padding: '8px 0',
      minWidth: '160px',
      fontFamily: 'Sora',
    }

    // 显示菜单
    showSelectMenu.value = true
  }
}

// 选择全部项目
const handleSelectAll = () => {
  // 通知父组件选择所有项目
  props.onSelectChange('all', selectAllRows.value)
  // 隐藏菜单
  showSelectMenu.value = false
}

// 只选择当前页
const onSelectChange = (selectedRowKeys, selectedRows) => {
    const dataSource = props.dataSource || []
  const currentPageIds = dataSource.map(item => item?.id).filter(Boolean)
  
  // 从所有选中项中移除当前页的项
  const otherPageSelectedKeys = (props.selectedRowKeys || []).filter(key => !currentPageIds.includes(key))
  
  // 合并当前页的选中项和其他页的已选中项
  const allSelectedKeys = [...new Set([...selectedRowKeys, ...otherPageSelectedKeys])]
  
  props.onSelectChange(allSelectedKeys, selectedRows)
}
const handleSelectThisPage = () => {
  // 过滤掉undefined项，确保只传递有效的行数据
  const validRows = selectAllRows.value.filter((item) => item && item.id)
  // 传递'page'字符串给父组件，让父组件处理当前页选择逻辑
  props.onSelectChange('page', validRows)
  // 隐藏菜单
  showSelectMenu.value = false
}

// 单选操作
const onSelect = (record, selected, selectedRows) => {
  // 这里可以添加额外的单选逻辑
  // 默认使用父组件的onSelectChange处理
  // 防止selectedRows为空
  if (!selectedRows || !Array.isArray(selectedRows)) {
    console.log('onSelect called with invalid selectedRows')
    props.onSelectChange([], [])
    return
  }

  // 获取当前页面的所有选中行ID
  const currentPageSelectedKeys = selectedRows
    .filter((row) => row && row.id)
    .map((row) => row.id)

  // 合并当前页面的选中行和不在当前页面的已选中行
  // 确保props.dataSource和props.selectedRowKeys存在
  const dataSource = props.dataSource || []
  const selectedRowKeys = props.selectedRowKeys || []

  const allSelectedKeys = [
    ...new Set([
      ...currentPageSelectedKeys,
      // 添加不在当前页面但已选中的行
      ...selectedRowKeys.filter((key) => {
        // 检查key是否不在当前页面的数据中
        return !dataSource.some((item) => item && item.id === key)
      }),
    ]),
  ]

  console.log('onSelect called:', {
    record,
    selected,
    currentPageSelectedKeys,
    allSelectedKeys,
  })
  props.onSelectChange(allSelectedKeys, selectedRows)
}
const showDeactivateModal = ref(false)
const tableRef = ref(null)
const recordSuerModal = ref({})

// 监听表格加载完成，用于自定义全选处理
onMounted(() => {
  // 给表格添加点击事件，用于拦截全选操作
  const tableElement = tableRef.value?.$el
  if (tableElement) {
    tableElement.addEventListener('click', handleTableClick, true)
  }

  // 添加点击外部关闭菜单的事件监听
  document.addEventListener('click', handleClickOutside)
})

// 清理事件监听
onUnmounted(() => {
  const tableElement = tableRef.value?.$el
  if (tableElement) {
    tableElement.removeEventListener('click', handleTableClick, true)
  }

  // 移除点击外部关闭菜单的事件监听
  document.removeEventListener('click', handleClickOutside)
})

// 拦截表格的全选操作
const handleTableClick = (e) => {
  // 只拦截表头的全选复选框点击事件，不影响单个行的选择
  if (
    e.target.closest(
      '.ant-table-thead .ant-table-selection-column .ant-checkbox',
    )
  ) {
    // 阻止表格默认的全选行为
    e.preventDefault()
    e.stopPropagation()
  }
}

// 点击外部关闭菜单
const handleClickOutside = (e) => {
  const menuElement = document.querySelector('.select-menu')
  const checkboxElement = document.querySelector(
    '.ant-table-thead .ant-table-selection-column .ant-checkbox',
  )

  if (
    menuElement &&
    !menuElement.contains(e.target) &&
    !checkboxElement?.contains(e.target)
  ) {
    showSelectMenu.value = false
  }
}
const modalConfigs = ref({
  open: false,
  modalType: 'deactive',
  activeTab: '0',
  type: 'single',
})
const suerModalConfigs = ref({
  open: false,
  modalType: 'active',
  activeTab: '0',
  type: 'single',
  productCountInfo: 0,
})
const singleRecord = ref({}) //列表的单条数据
const props = defineProps([
  'listTotal',
  'setParams',
  'setShowSetCommission',
  'setSelectedRowKeys',
  'setSelectSingleProduct',
  'params',
  'dataSource',
  'loading',
  'selectedRowKeys',
  'onSelectChange',
  'getProductList',
  'onChangeActiveItems',
  'brandswithAvailableProducts',
  'noData',
  'activeTab',
])
const { t, locale } = useI18n()
const nextScheduledProductStatus = (record) => {
  locale.value
  const isCurrentlyActive =
    props.activeTab === '0'
      ? record.status === 'active'
      : record.associateStatus === 'active'
  return isCurrentlyActive
    ? t('seller.common.inactive')
    : t('seller.common.active')
}
const showActiveModal = ref(false)
const hasVariations = ref(false)
let currItem = {}

const confirmInactive = async () => {
  showDeactivateModal.value = false
  await changeActive(currItem)
}

const setShowDeactivateModal = (status) => {
  showDeactivateModal.value = status
}
const setShowActivateModal = (status) => {
  showActiveModal.value = status
}

const getProductColumn = () => ({
  title: t('seller.productTable.colProduct'),
  dataIndex: 'title',
  width: 300,
  customRender: ({ text, record }) => {
    return (
      <a
        href={`/seller/product/${record.id}`}
        target="_blank"
        class="product-item">
        <img src={record.imageUrl} />
        <div class="text">
          <p class="title">{text}</p>
          <div class="asin-vc-icon">
            <span class="asin">{record.asin}</span>
            {record.amazonProfileAccountInfoType == 'vendor' ? (
              <VcIcon type="Products" />
            ) : null}
          </div>
        </div>
      </a>
    )
  },
})
const buildColumnsTab0 = () => [
  getProductColumn(),
  {
    title: t('seller.productTable.colStatus'),
    dataIndex: 'id',
    name: 'status',
    width: 185,
  },
  {
    title: t('seller.productTable.colBrand'),
    dataIndex: 'brandName',
    width: 150,
  },
  {
    title: t('seller.productTable.colAmazonSellerName'),
    dataIndex: 'amazonName',
    name: 'amazonName',
    width: 195,
  },
  {
    title: t('seller.productTable.colCategory'),
    dataIndex: 'category',
    width: 200,
  },
  {
    width: 100,
    title: t('seller.productTable.colDeal'),
    name: 'deal',
    dataIndex: 'productDeals',
  },
  {
    title: t('seller.productTable.colPrice'),
    dataIndex: 'price',
    name: 'price',
    width: 120,
  },
  {
    title: t('seller.productTable.colCommission'),
    dataIndex: 'attributionCommission',
    name: 'attributionCommission',
    width: 185,
  },
  {
    name: 'availiability',
    title: t('seller.productTable.colAvailability'),
    dataIndex: 'availiability',
    width: 114,
    customRender: ({ text }) =>
      text == 'IN_STOCK'
        ? t('seller.brandsPage.inStock')
        : t('seller.brandsPage.outOfStock'),
  },
  {
    name: 'action',
    title: t('seller.productTable.colAction'),
    dataIndex: 'id',
    fixed: 'right',
    width: 160,
  },
]
const buildColumnsTab1 = () => [
  getProductColumn(),
  {
    title: t('seller.productTable.colAssociateStatus'),
    dataIndex: 'associateStatus',
    name: 'associateStatus',
    width: 185,
  },
  {
    title: t('seller.productTable.colBrand'),
    dataIndex: 'brandName',
    width: 150,
  },
  {
    title: t('seller.productTable.colAmazonSellerName'),
    dataIndex: 'amazonName',
    name: 'amazonName',
    width: 195,
  },
  {
    title: t('seller.productTable.colCategory'),
    dataIndex: 'category',
    width: 200,
  },
  {
    width: 100,
    title: t('seller.productTable.colDeal'),
    name: 'deal',
    dataIndex: 'productDeals',
  },
  {
    title: t('seller.productTable.colPrice'),
    dataIndex: 'price',
    name: 'price',
    width: 120,
  },
  {
    name: 'action',
    title: t('seller.productTable.colAction'),
    dataIndex: 'id',
    fixed: 'right',
    width: 160,
  },
]
const applyColumnWidthsFromData = (data) => {
  if (!columns.value?.length) return
  let hasPromoCode = false
  let hasCombineDeal = false
  let hasProductDeal = false

  for (const product of data || []) {
    if (!product) continue
    if (product.combineDeal) {
      hasCombineDeal = true
    }

    if (product.productDeals?.length) {
      hasProductDeal = true

      for (const deal of product.productDeals) {
        if (deal.promoCode) {
          hasPromoCode = true
          break
        }
      }
    }

    if (hasCombineDeal && hasPromoCode) {
      break
    }
  }

  if (hasCombineDeal) {
    columns.value[5]['width'] = 180
  } else {
    columns.value[5]['width'] = 120
  }

  if (hasPromoCode) {
    columns.value[0]['width'] = 320
    columns.value[4]['width'] = 300
  } else if (hasProductDeal) {
    columns.value[0]['width'] = 360
    columns.value[4]['width'] = 170
  } else {
    columns.value[0]['width'] = 400
    columns.value[4]['width'] = 100
  }
}
const columns = ref([])
const returnAttributionCommissionBottom = (record) => {
  let str = ''
  if (record?.commissionChangeOperations) {
    if (record?.commissionChangeOperations?.length) {
      const changeTo = record?.commissionChangeOperations[0]?.changeTo
      if (changeTo) {
        try {
          const parsed = JSON.parse(changeTo)
          const rate = parsed.commissionRate ?? parsed.commission_rate
          if (rate != null && rate !== '') {
            str = String(rate)
          }
        } catch (e) {
          str = ''
        }
      }
    }
  }
  return str !== '' ? `${str}%` : '0%'
}
const returnAttributionCommission = (record) => {
  if (!record) return '0%'
  let str = ''
  if (record?.currentCommissionVO) {
    if (Object.keys(record?.currentCommissionVO).length) {
      str = record?.currentCommissionVO?.commission + '%'
    } else {
      str = record?.commission + '%'
    }
  } else {
    str = record?.commission + '%'
  }
  return str || '0%'
}
const onSetCommission = (id, record,type) => {
  props.setShowSetCommission(true)
  props.setSelectSingleProduct(id, record,type)
}
const cancelBrand = async (record,type) => {
  recordSuerModal.value = record
  recordSuerModal.value.listType = type
  suerModalConfigs.value.open = true
  suerModalConfigs.value.modalType = 'active'
  suerModalConfigs.value.activeTab = modalConfigs.value.activeTab
  suerModalConfigs.value.type = 'single'
}
const onChangePage = (data) => {
  const { current, pageSize } = data
  let newParams = { ...props.params }
  newParams.page = current
  newParams.size = pageSize

  props.setParams(newParams)
  props.getProductList(true)
}
const changeActive = async (record) => {
  let { status, id ,brandId} = record
  let params = [id]
  if (props.activeTab == '0') {
    status = status === 'active' ? 'inactive' : 'active'
  } else {
    status = record.associateStatus === 'active' ? 'inactive' : 'active'
  }
  emit('multiCancel', [singleRecord.value.id], status,brandId)

  // props.onChangeActiveItems(status, params)
}
const activateProduct = async () => {
  setShowActivateModal(false)
  await changeActive(currItem)
}
const getProductVariations = async (record, status) => {
  currItem = record
  let { id } = currItem
  let hasVariation = false
  let res = await productsApi.getProductVariations([id])
  if (
    res.data.activeProductVariationCount ||
    res.data.inactiveProductVariationCount
  ) {
    hasVariation = true
  }
  if (status == 'activate') {
    if (hasVariation) {
      setShowActivateModal(true)
    } else {
      changeActive(record)
    }
  }
  if (status == 'deactivate') {
    if (hasVariation) {
      hasVariations.value = true
    } else {
      hasVariations.value = false
    }
    setShowDeactivateModal(true)
  }
}

watch(
  () => props.dataSource,
  (data) => {
    applyColumnWidthsFromData(data)
  },
)
watch(
  () => [props.activeTab, locale.value],
  () => {
    columns.value =
      props.activeTab == '0' ? buildColumnsTab0() : buildColumnsTab1()
    applyColumnWidthsFromData(props.dataSource)
  },
  { immediate: true },
)
const onModalCancel = () => {
  modalConfigs.value.open = false
}
const onOpenModal = (record, modalType) => {
  singleRecord.value = record

  switch (modalType) {
    case 'deactive':
      modalConfigs.value.modalType = 'deactive'
      modalConfigs.value.open = true
      modalConfigs.value.activeTab = props.activeTab
      modalConfigs.value.type = 'single'
      break
    case 'activate':
      modalConfigs.value.modalType = 'active'
      modalConfigs.value.open = true
      modalConfigs.value.activeTab = props.activeTab
      modalConfigs.value.type = 'single'
      break
  }
}
const onModalOK = (item) => {
  modalConfigs.value.open = false
  changeActive(item)
}
const onMultiOK = (selectedRowKeys, modalType, productCountInfo) => {
  suerModalConfigs.value.type = 'multi'
  suerModalConfigs.value.selectedRowKeys = selectedRowKeys
  suerModalConfigs.value.productCountInfo = productCountInfo
  suerModalConfigs.value.modalType = modalType
  suerModalConfigs.value.open = true
}
const onSureOK = async (item) => {
  if (suerModalConfigs.value.type == 'single') {
    let operationId
    if(item.listType==='commissionChangeOperations'){
      operationId = item.commissionChangeOperations[0].operationId
    }
    else{
      operationId = item.statusChangeOperations[0].operationId
    }
    const data = await brandApi.cancelTask({
      operationId: operationId,
    })
    if (data.success) {
      message.success(t('seller.brandsPage.cancelSuccess'), 1)
      suerModalConfigs.value.open = false
      emit('cancel')
    }
  } else {
    suerModalConfigs.value.open = false
    modalConfigs.value.open = false
    emit(
      'multiCancel',
      suerModalConfigs.value.selectedRowKeys,
      suerModalConfigs.value.modalType,
    )
  }
}
const onSureCancel = () => {
  suerModalConfigs.value.open = false
}
const initData = (status, ids, activeTab, productCount) => {
  // props.setSelectedRowKeys(ids)
  productCountInfo.value = productCount
  modalConfigs.value.modalType = status
  modalConfigs.value.open = true
  modalConfigs.value.activeTab = activeTab
  modalConfigs.value.type = 'multi'
}
defineExpose({
  initData,
})
// setTimeout(()=>{
//   suerModalConfigs.value.open=true
// },100)
</script>

<style lang="less" scoped>
.ant-btn.artmisads-select-button:disabled{
  background-color: rgba(204, 199, 217, 1) !important;
  color: rgba(15, 6, 41, 0.5) !important;
}
.table {
  position: relative;
  min-height: 100vh;
  padding-bottom: 46px; /* 为底部内容预留空间 */
}
.active-publishers {
  text-decoration: underline;
}

.amazon-name {
  white-space: pre-wrap !important;
}

.re-fetch-wrap {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

:deep(.ant-table) {
  .ant-table-cell {
    padding: 16px 8px;
  }

  .set-commission {
    > button {
      &:first-child {
        margin-bottom: 8px;
      }
    }
  }

  table {
    table-layout: fixed !important;
  }

  .inactive-commission {
    color: var(--dark-4);
  }

  .status-text {
    text-transform: capitalize;
  }

  .product-item {
    display: flex;

    .asin-vc-icon {
      display: flex;
      align-items: center;
      // justify-content: flex-end;
      gap: 4px;
    }

    img {
      width: 56px;
      height: 56px;
      margin-right: 12px;
      // border: 1px solid var( --border-1);
      border-radius: 8px;
      object-fit: contain;
    }

    .text {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      justify-content: center;

      .title {
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--dark-1);
        font-weight: 500;
        font-size: var(--font-size-middle);
        text-decoration: underline;
      }

      .asin {
        color: var(--dark-3);
        font-weight: 500;
        font-size: var(--font-size-min);
        letter-spacing: 0.3px;
        text-align: right;
        line-height: 16px;
        text-align: left;
        margin-top: 2px;
      }
    }
  }

  .no-amazonName,
  .no-deal {
    color: var(--dark-3);
  }
}

.time {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(245, 246, 247, 1);
  border-radius: 6px;
  padding: 4px 8px;
  margin-top: 10px;
  .time-mid {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.time-month {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  color: rgba(15, 6, 41, 0.7);
  letter-spacing: 0.4px;
}

.close-icon {
  font-size: 13px;
  color: rgba(15, 6, 41, 0.2);
}

.cancelBtn {
  cursor: pointer;
  margin-top: 10px;
  max-width: 70px;
  font-family: Sora;
  font-weight: 500;
  font-size: 13px;
  color: rgba(235, 78, 61, 1);
  line-height: 18px;
  letter-spacing: 0.3px;
  padding: 3px 11px;
  text-align: center;
  background-color: rgba(254, 238, 236, 1);
  border: 1px solid rgba(245, 119, 105, 1);
  border-radius: 6px;
}

/* 自定义全选菜单样式 */
.select-menu {
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 8px 0;
  min-width: 160px;
  font-family: Sora;
}

.select-menu-item {
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(15, 6, 41, 0.9);
  cursor: pointer;
  transition: background-color 0.2s;
  text-align: left;
  white-space: nowrap;
}

.select-menu .menu-item:hover {
  background-color: rgba(241, 240, 245, 1);
}
</style>
